<template>
  <div>
    <div>
      <div>This is a file set based workout plan. Please choose a file set:</div>
      <select class="form-control" v-model="selectedWorkoutFileSet" :disabled="workoutPlanIsApproved">
        <option disabled value="">Please select one</option>
        <option v-for="(fileset, index) in workoutFileSets" v-bind:key="index" v-text="fileset.name" :value="fileset"></option>
      </select>
    </div>

    <div v-if="selectedWorkoutFileSet" class="my-2">
      <div class="card" v-for="(asset, index) in selectedWorkoutFileSet.assets" v-bind:key="index">
        <!-- <div class="card-header">{{ asset.name }}</div> -->
        <div class="card-body">
          <h5 class="card-title">{{ asset.name }} <span class="badge badge-pill badge-primary">{{ asset.pivot.type }}</span></h5>
          <p class="card-text">
              <a :href="asset.url" class="btn btn-default"><i class="mdi mdi-download"></i> Download</a>
          </p>
        </div>
      </div>
    </div>
    <button class="btn btn-success mt-2" :disabled="!canApproveWorkoutPlan" @click="updateWorkoutFileSet()"><i class="mdi mdi-thumb-up" /> Save & Approve Workout Plan</button>
    <button class="btn btn-secondary mt-2" v-if="!canApproveWorkoutPlan" @click="disapproveWorkoutPlan"><i class="mdi mdi-thumb-down" /> Disapprove Workout Plan</button>
  </div>
</template>
<script>
  export default {
    props: [
      'initialWorkoutPlan'
    ],
    components: {
    },
    data() {
      return {
        workoutPlan: this.initialWorkoutPlan,
        workoutFileSets: [],
        selectedWorkoutFileSet: this.initialWorkoutPlan.workout_file_set,
        isLoading: false,
        showAddWeekModal: false,
        newWeek: {
          name: null
        }
      }
    },
    mounted() {
      this.getWorkoutFileSets();
    },
    computed: {
      workoutPlanIsApproved: function() {
        return this.workoutPlan.approved_at != null;
      },
      availableWorkoutPrograms: function() {
        return this.$root.availableWorkoutPrograms;
      },
      canApproveWorkoutPlan: function() {
        return this.selectedWorkoutFileSet != null && !this.workoutPlanIsApproved;
      },
      numWeeks: function() {
        return this.workoutPlan.weeks.length;
      }
    },
    methods: {
      getWorkoutFileSets: function () {
        var _this = this;
        _this.isLoading = true;

        axios.get('/api/workout_file_sets').then(function (response) {
          _this.workoutFileSets = response.data.data;
          _this.isLoading = false;
        });
      },
      updateWorkoutFileSet: function () {
        console.log("Selected workout file set: " + this.selectedWorkoutFileSet.id)
        var _this = this;
        _this.isLoading = true;

        axios.put('/api/workout_plans/' + _this.workoutPlan.id, {
          workout_file_set_id: this.selectedWorkoutFileSet.id,
          approve: true,
        }).then(function (response) {
          // _this.workoutPlan = response.data.data;
          _this.isLoading = false;
          _this.$emit('workout-plan-updated');
          _this.$toasted.success("Workout File Set Updated!")
        })
        .catch(e => {
          _this.$toasted.error(e.response.data.message);
          _this.isLoading = false;
        });
      },
      disapproveWorkoutPlan: function () {
        var _this = this;
        _this.isLoading = true;

        axios.put('/api/workout_plans/' + _this.workoutPlan.id, {
          approve: false,
        }).then(function (response) {
          // _this.workoutPlan = response.data.data;
          _this.isLoading = false;
          _this.$emit('workout-plan-updated');
          _this.$toasted.success("Workout Plan Updated!")
        })
        .catch(e => {
          _this.$toasted.error(e.response.data.message);
          _this.isLoading = false;
        });
      },
    },
    watch: {
      initialWorkoutPlan: function (newVal,oldVal) {
        Vue.set(this, 'workoutPlan', newVal);
      }
    }
}
</script>
